import Datepicker from 'components/Varios/Datepicker';
import { isWeekday } from 'functions/CalendarFunctions';
import React, { useCallback, useEffect, useState } from 'react'
import { Container, Row, Col, Label, Form, FormGroup, Button,Input } from "reactstrap";
import { GetHojaMarcacion } from './ServicesHojaMarcaciones';
import { showAlertSwal } from 'components/Admin/AprobacionesSolicitudes/AprobacionSolicitudesTh';
import ModalVistaPreviaDocumentos from 'components/Varios/Modals/ModalVistaPreviaDocumentos';

export type PropsHojaMarcaciones = {
    ingresaIdentificacion: boolean
}

export default function HojaMarcaciones(props: PropsHojaMarcaciones) {
    const [fechaDesde, setfechaDesde] = useState<Date | null>(null)
    const [fechaHasta, setfechaHasta] = useState<Date | null>(null)
    const [loading, setloading] = useState<boolean>(false)
    const [urlHojaMarcacion, seturlHojaMarcacion] = useState<string>("")
    const [identificacion, setidentificacion] = useState<string>("")
    const fechaMinima = new Date(2024, 10, 1);




    useEffect(() => {
        const fechaActual = new Date();
        const mesActual = fechaActual.getMonth();
        const anioActual = fechaActual.getFullYear();

        const fechaDesde = new Date(fechaActual.getFullYear(), fechaActual.getMonth(), 1)
        setfechaDesde(fechaDesde)
        setfechaHasta(fechaActual)
    }, [])





    const disabledGeneral = false;

    const OnChange = useCallback((name: string, valor: any) => {

        if (name === "fechadesde") {
            setfechaDesde(valor)
            if (fechaHasta && new Date(fechaHasta).getMonth() !== new Date(valor).getMonth()) {
                setfechaHasta(null);
            }
        }
        else if (name === "fechahasta") {
            setfechaHasta(valor);
        }
    }, [fechaDesde, fechaHasta])




    async function GetHojaMarcacionesPDF(fechaDesde: Date, fechaHasta: Date,identificacion:string = "") {
        setloading(true)

        const response = await GetHojaMarcacion(fechaDesde, fechaHasta,identificacion);

        if (response.status === 200 && response.dataResponse) {
            seturlHojaMarcacion(response.dataResponse)
        }
        else if(response.status === 409){

            showAlertSwal(response.errorMessage??"No ha sido posible generar su hoja de marcaciones", false)
        }
        else {
            showAlertSwal("No ha sido posible generar su hoja de marcaciones", false)
        }

        setloading(false)
    }

    return (
        <div className="content">
            <Container fluid>
                <Row>
                    <Col>
                        <h5>REGISTRO ENTRADA - SALIDA DEL PERSONAL</h5>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className="mensajesAviso"> Esta opción debe ser usada para consultar las marcaciones a partir del 1 de noviembre del 2024</div>
                    </Col>
                </Row>
                <Form>
                    <Row className="justify-content-center">
                        {
                            props.ingresaIdentificacion === true &&
                            <Col xs={12} lg={2} xl={2}>
                                <FormGroup>
                                    <Label for="identificacion">
                                        Identificación
                                    </Label>
                                    <Input type="text" value = {identificacion} onChange = {(e) => setidentificacion(e.target.value)} />
                                </FormGroup>
                            </Col>
                        }
                        <Col xs={12} lg={2} xl={2}>
                            <FormGroup>
                                <Label for="fechadesde">
                                    Desde:
                                </Label>
                                <Datepicker
                                    value={fechaDesde}
                                    disabled={disabledGeneral}
                                    name="fechadesde"
                                    id="fechadesde"
                                    onChange={(e, name) => OnChange(name, e)}
                                    min={fechaMinima}
                                    max={new Date()}
                                    //filter={(date: Date) => isWeekday(date) }
                                    showDisabledMonthNavigation={true}
                                    monthdropdown={true}
                                    portalId = {"root"}
                                />
                            </FormGroup>
                        </Col>
                        <Col xs={12} lg={2} xl={2}>
                            <FormGroup>
                                <Label for="fechahasta">
                                    Hasta:
                                </Label>
                                {
                                    fechaDesde === null &&
                                    <Datepicker
                                        disabled={true}
                                    />
                                }
                                {
                                    fechaDesde &&
                                    <Datepicker
                                        value={fechaHasta}
                                        disabled={disabledGeneral || fechaDesde === null}
                                        name="fechahasta"
                                        id="fechahasta"
                                        onChange={(e, name) => OnChange(name, e)}
                                        min={fechaDesde}
                                        max={new Date(fechaDesde.getFullYear(), fechaDesde.getMonth() + 1, 0)}
                                        //filter={(date: Date) => isWeekday(date) }
                                        showDisabledMonthNavigation={false}
                                        monthdropdown={false}
                                        portalId = {"root"}
                                    />
                                }

                            </FormGroup>
                        </Col>
                    </Row>
                    <Row className="justify-content-center">
                        {
                            fechaDesde && fechaHasta && (props.ingresaIdentificacion === false || (props.ingresaIdentificacion === true && identificacion !== "")) &&
                            <Button
                                onClick={() => GetHojaMarcacionesPDF(fechaDesde, fechaHasta,identificacion)}
                            >
                                Generar Reporte</Button>
                        }
                        {
                            (fechaDesde === null || fechaHasta === null || ( props.ingresaIdentificacion === true && identificacion === "") ) &&
                            <Button disabled>Generar Reporte</Button>
                        }

                    </Row>
                </Form>

                <ModalVistaPreviaDocumentos
                    show={urlHojaMarcacion !== "" || loading}
                    urlArchivo={urlHojaMarcacion}
                    cargandoDatos={loading}
                    size='xl'
                    onClose={() => seturlHojaMarcacion("")}
                    tituloModal=''
                    
                />


            </Container>
        </div>
    )
}
